/**
 * Nama brand produk SaaS (yang dilihat operator di admin panel).
 * Sumber tunggal — ganti di sini untuk merebranding seluruh admin
 * (judul tab via BrandTitleStrategy, sidebar, halaman login, dll).
 */
export const BRAND = 'Qafilah';

/** Subjudul/tagline brand (di bawah logo pada halaman login, dll). */
export const BRAND_TAGLINE = 'Sistem Manajemen Travel Umrah & Haji';
